import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { getGroupsQueryOptions } from '@/core/components/sites/propertyQueryOptions'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/dashboard/commissions/')({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({ to: '/' })
    }

    if (auth.user?.role !== Role['Internal']) {
      throw redirect({ to: '/dashboard' })
    }
  },
  loader: ({ context: { queryClient, auth } }) => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    queryClient.ensureQueryData(getGroupsQueryOptions(auth.token as string))
  },
  errorComponent: ErrorComponent,
  pendingComponent: LoadingList,
})
